import React from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  UnauthorisedPageSurface,
  PageWrapper,
} from "../../../../components/layout/container/Container";
import { FormSection } from "../../../../components/layout/forms/Index";
import TextField from "../../../../components/input/textfield/TextField";

import { useSignUp } from "../hooks/useSignUp";
import StatusAlert from "../../../../components/alerts/StatusAlert";
import "./SignUpPage.css";

import Button from "../../../../components/buttons/Button";
import { PageHeader } from "../../../../components/layout/header/Header";
import { PageHeading } from "../../../../components/common/heading/Heading";
import FeedbackStatus from "../../../../components/feedback/FeedbackStatus";

const SignUpPage = () => {
  document.title = "Katch | Sign up";

  const navigate = useNavigate();
  const { formData, status, handleChange, handleSubmit } = useSignUp();

  if (status.success) {
    return (
      <div className="sign-up-content">
        <FeedbackStatus
          title={"Verify your email"}
          description={
            <span>
              We've sent a link to <b>{formData.email || "your email"}</b>.
              Please check your inbox or spam folder to activate your account.
            </span>
          }
          buttonText={"Back to Sign in"}
          onAction={() => navigate("/sign-in")}
        />
      </div>
    );
  }

  return (
    <UnauthorisedPageSurface>
      <PageWrapper size={"sm"}>
        <div className="sign-up-content">
          <PageHeader>
            <PageHeading
              title={"Create account"}
              subTitle={
                <span>
                  Already have an account?{" "}
                  <Link
                    to="/sign-in"
                    style={{ color: "var(--ko-primary-blue-3)" }}
                  >
                    Sign in
                  </Link>
                </span>
              }
            />
          </PageHeader>

          <form>
            <FormSection>
              {status.message && <StatusAlert status={status} />}

              <TextField
                name="firstName"
                label="First name"
                value={formData.firstName}
                onChange={handleChange}
                placeholder="Enter your first name"
                required
              />

              <TextField
                name="lastName"
                label="Last name"
                value={formData.lastName}
                onChange={handleChange}
                placeholder="Enter your last name"
                required
              />
            </FormSection>

            <FormSection>
              <TextField
                name="email"
                type="email"
                label="Email address"
                value={formData.email}
                onChange={handleChange}
                placeholder="name@example.com"
                required
              />

              <TextField
                name="password"
                type="password"
                label="Password"
                value={formData.password}
                onChange={handleChange}
                placeholder="At least 8 characters"
                showPasswordOption
                required
              />
            </FormSection>

            <label
              className="mbr-access-form__checkbox-container"
              style={{ marginBottom: "2rem", display: "flex" }}
            >
              <input
                type="checkbox"
                name="agreement"
                checked={formData.agreement}
                onChange={handleChange}
                className="mbr-access-form__checkbox"
                required
              />
              <span
                className="mbr-access-form__disclaimer"
                style={{ marginLeft: 8, fontSize: 14 }}
              >
                I agree to the{" "}
                <a href="/u/terms" target="_blank" rel="noreferrer">
                  Terms
                </a>{" "}
                &{" "}
                <a href="/privacy" target="_blank" rel="noreferrer">
                  Privacy Policy
                </a>
              </span>
            </label>

            <Button
              value={status.loading ? "Creating account..." : "Create account"}
              style={{ width: "100%" }}
              onClick={handleSubmit}
              disabled={status.loading}
            />
          </form>
        </div>
      </PageWrapper>
    </UnauthorisedPageSurface>
  );
};

export default SignUpPage;
